import 'intl';
import 'intl/locale-data/jsonp/en';

export const dollarAmounts = (value: any) => {
  if (!value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(0);
  }

  const intValue = parseInt(value);
  const result = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(intValue);

  return result;
};

export const dollarAmountsFloat = (value: any, isCents: boolean = false) => {
  if (!value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(0.0);
  }

  let floatValue = parseFloat(parseFloat(value).toFixed(2));
  if (isCents) {
    floatValue = floatValue / 100;
  }

  const result = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(floatValue);

  return result;
};

export function formatCurrency(
  value: number | string | undefined | null
): string {
  const num = Number(value);

  if (isNaN(num)) {
    return '–';
  }

  const absNum = Math.abs(num);

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });

  let result: string;

  if (absNum < 1_000) {
    result = `$${Math.floor(num)}`;
  } else if (absNum < 1_000_000) {
    result = `$${formatter.format(num / 1_000)}k`;
  } else if (absNum < 1_000_000_000) {
    result = `$${formatter.format(num / 1_000_000)}M`;
  } else if (absNum < 1_000_000_000_000) {
    result = `$${formatter.format(num / 1_000_000_000)}B`;
  } else {
    result = `$${formatter.format(num / 1_000_000_000_000)}T`;
  }

  return result;
}

export function formatViews(value: number | undefined): string {
  if (!value) {
    return '–';
  }

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });

  let result: string;

  if (value < 1_000) {
    result = `${Math.floor(value)}`;
  } else if (value < 1_000_000) {
    result = `${formatter.format(value / 1_000)}k`;
  } else if (value < 1_000_000_000) {
    result = `${formatter.format(value / 1_000_000)}M`;
  } else if (value < 1_000_000_000_000) {
    result = `${formatter.format(value / 1_000_000_000)}B`;
  } else {
    result = `${formatter.format(value / 1_000_000_000_000)}T`;
  }

  return result;
}

export function searchResultFormatViews(
  view: number | undefined,
  featured: number | undefined
): string {
  const value = (view || 0) + (featured || 0);
  if (!value) {
    return '–';
  }

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });

  let result: string;

  if (value < 1_000) {
    result = `${Math.floor(value)}`;
  } else if (value < 1_000_000) {
    result = `${formatter.format(value / 1_000)}k`;
  } else if (value < 1_000_000_000) {
    result = `${formatter.format(value / 1_000_000)}M`;
  } else if (value < 1_000_000_000_000) {
    result = `${formatter.format(value / 1_000_000_000)}B`;
  } else {
    result = `${formatter.format(value / 1_000_000_000_000)}T`;
  }

  return result;
}

export function calculateConversion(views: number, sales: number): string {
  if (views <= 0 || sales < 0 || isNaN(views) || isNaN(sales)) {
    return '–'; // дефис для некорректных значений
  }

  const rate = (sales / views) * 100;
  return `${rate.toFixed(2)}%`;
}

export function formatAvg(value: string | undefined): string {
  const num = Number(value);

  if (isNaN(num)) {
    return '–';
  }

  return num.toFixed(1);
}
